<template lang="pug">
div
  #preloader(v-if="gameLaunching|| favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2(v-if="favList.length>0")
      template(v-for="game in filteredList()")
        .gggl
          router-link(v-if="isLoggedIn" :to="`/launchGame?p=${game.provider_code}&game=${game.game_code}`" target="_blank")
            .iimg
              img.img-fluid(:src='game.img_url')
          a(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
            .iimg
              img.img-fluid(:src='game.img_url')
          //- .prov(:class="{'c-filter2': game.provider_code == 'HSD' || game.provider_code == 'RG'}")
            img(:src="`/new/img/provider/${game.provider_code}.png`")
          .fav.aaa
            i.fa-solid.fa-heart.pointer( @click="removeFav(game.provider_code,game.game_code)")
          .name {{game.game_name}}
    template(v-else)
      .text-center.text-white.my-4.w-100
        i.fa-regular.fa-newspaper.display-6.text-black
        .text-black No data
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
export default {
	props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
	data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      items:[],
      offList:[],
      // searchinput: "",
      favListAction: false,
			path:"",
      mobileDevice: false,
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
		favList(){
			return this.$store.getters.getFavlist.filter((x)=>x.game_type === "MINIGAME")
		}
  },
  mounted(){
  },
	methods:{
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
		removeFav(provider, game){
			if (this.sessionToken) {
				this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
						this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
						this.favListAction = false
          });
      }
		},
		filteredList(){
      return this.favList.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
	}
}
</script>